import { baseClient } from '../api/fetch'

export const ASSETS2_URL = '/api/assets'

export const assets2Client = baseClient({})

export const getClientAvatarUrl = (clientId: number): string => {
  return `${ASSETS2_URL}/client_avatars/${clientId}`
}

export const getUserAvatarUrl = (userId: number): string => {
  return `${ASSETS2_URL}/user_profiles/${userId}`
}
